/* eslint-disable */
/// This file is auto generated - do not edit manually
export const SkipToMainContent = 'Website.Shared.Accessibility.SkipToMainContent';
